import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.object.to-string.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from 'prop-types';
import { ObjectAssign } from './util';
/**
 * 参数: 过滤表头
 * @param {*} Table
 * @param {*} Checkbox
 * @param {*} Popover
 * @param {*} Icon
 */

export default function multiSelect(Table, Checkbox) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(MultiSelect, _Component);

    var _super = _createSuper(MultiSelect);

    function MultiSelect(props) {
      var _this;

      _classCallCheck(this, MultiSelect);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "checkAllSelected", function (data) {
        if (!_this.isArray(data)) return false;
        if (data.length == 0) return false;
        var count = 0;
        var disabledCount = 0;
        var length = 0;

        var getTree = function getTree(arr) {
          arr.forEach(function (item) {
            length++;

            if (item._checked && !item._disabled) {
              count++;
            } else if (item._disabled) {
              disabledCount++;
            }

            if (item.children) {
              getTree(item.children);
            }
          });
        };

        getTree(data);

        if (length == count + disabledCount && count > 0) {
          return "all";
        }

        return count == 0 ? false : "indeter";
      });

      _defineProperty(_assertThisInitialized(_this), "onAllCheckChange", function () {
        var _this$state = _this.state,
            data = _this$state.data,
            checkedAll = _this$state.checkedAll,
            indeterminate = _this$state.indeterminate;
        var check = false;

        if (checkedAll) {
          check = false;
        } else {
          check = true;
        }

        var selectList = [];
        data.forEach(function (item) {
          if (item.children) {
            var res = _this.setTree(item, check, true);

            selectList = selectList.concat(res);
          } else {
            if (!item._disabled) {
              item._checked = check;
            }

            if (item._checked) {
              selectList.push(item);
            }
          }
        });

        if (selectList.length > 0) {
          indeterminate = true;
        } else {
          indeterminate = false;
        }

        _this.setState({
          indeterminate: indeterminate,
          checkedAll: check
        });

        _this.props.getSelectedDataFunc(selectList, undefined, undefined, data);
      });

      _defineProperty(_assertThisInitialized(_this), "setTree", function (node, flag, autoSelect) {
        var res = [];

        var setTreeNodeFlag = function setTreeNodeFlag(node, flag) {
          if (!node._disabled) {
            node._checked = flag;
          }

          if (flag) {
            res.push(node);
          }

          if (node.children && autoSelect) {
            node.children.forEach(function (item) {
              setTreeNodeFlag(item, flag);
            });
          }
        };

        setTreeNodeFlag(node, flag);
        return res;
      });

      _defineProperty(_assertThisInitialized(_this), "getTree", function (node, key, value) {
        var res = [];

        var getTreeNodeByFlag = function getTreeNodeByFlag(node) {
          if (node[key] === value) {
            res.push(node);
          }

          if (node.children) {
            node.children.forEach(function (item) {
              getTreeNodeByFlag(item);
            });
          }
        };

        getTreeNodeByFlag(node);
        return res;
      });

      _defineProperty(_assertThisInitialized(_this), "onCheckboxChange", function (text, record, index) {
        return function () {
          var data = _this.state.data;
          var selectList = []; // record._checked = record._checked?false:true;

          var flag = record._checked ? false : true;

          if (record.children) {
            _this.setTree(record, flag, _this.props.autoSelect);
          } else {
            record._checked = flag;
          }

          var obj = _this.getCheckedOrIndeter(data);

          _this.setState(_objectSpread({
            data: data
          }, obj));

          data.forEach(function (da) {
            if (da.children) {
              selectList = selectList.concat(_this.getTree(da, '_checked', true));
            } else if (da._checked) {
              selectList.push(da);
            }
          });

          _this.props.getSelectedDataFunc(selectList, record, index, data);
        };
      });

      _defineProperty(_assertThisInitialized(_this), "getDefaultColumns", function (columns) {
        var multiSelectConfig = _this.props.multiSelectConfig;
        var _this$state2 = _this.state,
            checkedAll = _this$state2.checkedAll,
            indeterminate = _this$state2.indeterminate;
        var checkAttr = {
          checked: checkedAll ? true : false
        };
        var data = _this.props.data;
        var dataLength = data.length;
        var disabledCount = 0;
        indeterminate ? checkAttr.indeterminate = true : ""; //设置表头Checkbox是否可以点击

        data.forEach(function (item, index, arr) {
          if (item._disabled) {
            disabledCount++;
          }
        });
        var _defaultColumns = [{
          className: 'u-table-multiSelect-column',
          title: /*#__PURE__*/React.createElement(Checkbox, _extends({
            className: "table-checkbox"
          }, checkAttr, multiSelectConfig, {
            disabled: disabledCount == dataLength ? true : false,
            onChange: _this.onAllCheckChange
          })),
          key: "checkbox",
          dataIndex: "checkbox",
          fixed: "left",
          width: 49,
          render: function render(text, record, index) {
            var attr = {};
            record._disabled ? attr.disabled = record._disabled : "";
            return /*#__PURE__*/React.createElement(Checkbox, _extends({
              key: index,
              className: "table-checkbox"
            }, attr, multiSelectConfig, {
              checked: record._checked,
              onChange: _this.onCheckboxChange(text, record, index)
            }));
          }
        }];
        return _defaultColumns.concat(columns);
      });

      _defineProperty(_assertThisInitialized(_this), "onRowClick", function (record, index, event) {
        var _this$props = _this.props,
            autoCheckedByClickRows = _this$props.autoCheckedByClickRows,
            onRowClick = _this$props.onRowClick;

        if (autoCheckedByClickRows) {
          if (record._disabled) return; //disabled只控制checkbox不可用，不能影响onRowClick的回调

          _this.onCheckboxChange('', record, index)();
        }

        onRowClick && onRowClick(record, index, event);
      });

      var _obj = _this.getCheckedOrIndeter(props.data);

      _this.state = _objectSpread(_objectSpread({}, _obj), {}, {
        data: ObjectAssign(props.data)
      });
      return _this;
    }

    _createClass(MultiSelect, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if ('data' in nextProps) {
          var obj = this.getCheckedOrIndeter(nextProps.data);
          this.setState(_objectSpread(_objectSpread({}, obj), {}, {
            data: ObjectAssign(nextProps.data)
          }));
        }
      }
      /**
       * @param {*} data 
       */

    }, {
      key: "getCheckedOrIndeter",
      value: function getCheckedOrIndeter(data) {
        var obj = {};
        var checkStatus = this.checkAllSelected(data);

        if (!checkStatus) {
          obj.checkedAll = false;
          obj.indeterminate = false;
          return obj;
        }

        if (checkStatus == 'indeter') {
          obj.indeterminate = true;
          obj.checkedAll = false;
        } else if (checkStatus == 'all') {
          obj.checkedAll = true;
          obj.indeterminate = false;
        }

        return obj;
      }
      /**
       * 判断数据是否全部选中
       * @param {*} data 
       * return  string  all(全选)、indeter(半选)
       */

    }, {
      key: "setChecked",
      value: function setChecked(data) {
        if (!this.isArray(data)) return false;
        if (data.length == 0) return false;
        var count = 0;
        var disabledCount = 0;
        data.forEach(function (da) {
          if (da._checked && !da._disabled) {
            count++;
          }

          if (da._disabled) {
            disabledCount++;
          }
        });

        if (data.length == count + disabledCount && count > 0) {
          return "all";
        }

        return count == 0 ? false : "indeter";
      }
      /**
       * 重写：判断数据是否全部选中
       */

    }, {
      key: "isArray",
      value:
      /**
       * 判断是否是数组
       * @param {*} o 
       */
      function isArray(o) {
        return Object.prototype.toString.call(o) == '[object Array]';
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            columns = _this$props2.columns,
            expandIconColumnIndex = _this$props2.expandIconColumnIndex;
        var data = this.state.data;
        return /*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
          columns: this.getDefaultColumns(columns),
          data: data,
          onRowClick: this.onRowClick,
          expandIconColumnIndex: expandIconColumnIndex ? expandIconColumnIndex + 1 : 1
        }));
      }
    }]);

    return MultiSelect;
  }(Component), _defineProperty(_class, "propTypes", {
    autoCheckedByClickRows: PropTypes.bool //行点击时，是否自动勾选复选框

  }), _defineProperty(_class, "defaultProps", {
    prefixCls: "u-table-mult-select",
    getSelectedDataFunc: function getSelectedDataFunc() {},
    autoSelect: false,
    autoCheckedByClickRows: true,
    multiSelectConfig: {}
  }), _temp;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/lib/multiSelect.js